/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Funnel } from '../models/Funnel';
import type { FunnelStatus } from '../models/FunnelStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FunnelsService {
    /**
     * @returns Funnel Ok
     * @throws ApiError
     */
    public static getFunnels(): CancelablePromise<Array<Funnel>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/funnels',
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
    /**
     * @param funnelId
     * @param filterBy
     * @param searchBy
     * @param sortBy
     * @param page
     * @param pageSize
     * @param pageToken
     * @returns FunnelStatus Ok
     * @throws ApiError
     */
    public static getFunnelStatuses(
        funnelId: number,
        filterBy?: string,
        searchBy?: string,
        sortBy?: string,
        page?: number,
        pageSize?: number,
        pageToken?: string,
    ): CancelablePromise<Array<FunnelStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/funnels/{funnelId}/statuses',
            path: {
                'funnelId': funnelId,
            },
            query: {
                'filterBy': filterBy,
                'searchBy': searchBy,
                'sortBy': sortBy,
                'page': page,
                'pageSize': pageSize,
                'pageToken': pageToken,
            },
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
}
